import {fetchJSONByGet, fetchJSONByPost, fetchJSONByDel} from './index.js'

export const fetchSitesApi = (params, trigger = false) => fetchJSONByGet('/adms_api_v0/settings/site/page', params, {trigger})
export const fetchSiteApi = (id) => fetchJSONByGet(`/adms_api_v0/settings/site/${id}`)
export const delSiteApi = (id) => fetchJSONByDel(`/adms_api_v0/settings/site/${id}`)
export const updateSiteApi = (id, body) => fetchJSONByPost(`/adms_api_v0/settings/site/${id}`, body)
export const createSiteApi = (body) => fetchJSONByPost('/adms_api_v0/settings/site', body)